import { render, staticRenderFns } from "./grant.vue?vue&type=template&id=515a3754"
import script from "./grant.vue?vue&type=script&lang=js"
export * from "./grant.vue?vue&type=script&lang=js"
import style0 from "./grant.vue?vue&type=style&index=0&id=515a3754&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports